"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSortableHoc = require("react-sortable-hoc");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const SortableRowsInnerContainer = (0, _reactSortableHoc.SortableContainer)(props => {
  return props.children;
});
function copyCellSizes({
  node,
  index,
  collection
}, e) {
  if (node.tagName === 'TR') {
    const sortableHelperComponent = document.getElementsByClassName('sortable-helper-component')[0];
    for (let i = 0; i < node.children.length; i++) {
      sortableHelperComponent.style.backgroundColor = '#dff0d8';
      sortableHelperComponent.children[i].style.width = `${node.children[i].offsetWidth}px`;
      sortableHelperComponent.children[i].style.height = `${node.children[i].offsetHeight}px`;
    }
  }
}
class SortableRowsContainer extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onSortEnd", ({
      oldIndex,
      newIndex
    }) => {
      if (oldIndex !== newIndex) {
        const {
          items
        } = this.props;
        this.props.onSort((0, _reactSortableHoc.arrayMove)(items, oldIndex, newIndex));
      }
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(SortableRowsInnerContainer, _extends({}, this.props, {
      useDragHandle: true,
      helperClass: "table table-sm sortable-helper-component",
      lockAxis: "y",
      lockToContainerEdges: true,
      onSortStart: copyCellSizes,
      onSortEnd: this._onSortEnd
    }));
  }
}
var _default = exports.default = SortableRowsContainer;